export const REGEX = {
  passReset: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).*$/,
  email: /^[a-zA-Z0-9._+-]{2,64}@[a-zA-Z0-9.-]{2,253}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/,
  password: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^\sA-Za-z0-9]).{8,20}$/,
  passwordHints: {
    capitalLetter: /[A-Z]/,
    lowercaseLetter: /[a-z]/,
    specialLetter: /[^\w\s]/,
    hasDigit: /\d/,
  },
  name: /^(?! )[A-Za-z]+(?: [A-Za-z]+)*(?<! )$/,
  shopName: /^(?!\s)[A-Za-z0-9\s'",.&()/#-]{2,90}(?<!\s)$/,
  space: /\s/,
  digitCount: /d\{(\d+)\}/g,
  multipleSpaces: /\s+/g,
  nonDigitChar: /\D/g,
  nonAllowedChar: (char: string) => new RegExp(`[^\\s${char}]`, 'g'),
  shippingAddressAndState: /^(?!\s)([A-Za-z0-9.,\-/\s]{5,90})(?<!\s)$/,
  city: /^(?!\s)([A-Za-z.'\-\s]{3,90})(?<!\s)$/,
  state: /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{}|;:'",.<>?/\\ ]+$/,
  roleName: /^[A-Za-z0-9_-]+$/,
  roleDescription: /^[A-Za-z0-9_.,'"!?()\- ]+$/,
  url: /^\/[a-z0-9]+(?:-[a-z0-9]+)*(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)*$/,
  leadingOrTrailingWhitespace: /^\s|\s$/,
  description: /^(?!\s)(?=.{1,500}$)[\w\s.,:;!?()%#@&^*$'"`]+(?<!\s)$/,
  differentLocalesColon: /,(?=(?:[^"]*"[^"]*")*[^"]*$)/g,
  remarks: /^[A-Za-z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
  allowComment: /^[A-Za-z0-9\s.,!?@#$%^&*()\-_+=[\]{}|;:'",<>/\\]*$/,
  htmlTagPattern: /<[^>]*>/g,
  productDetails: {
    name: /^[\w-]+$/,
    digitValue: /^\d+(?:\.\d{1,2})?$/,
    stringValue: /^[\w ,.-]+$/,
  },
  loyaltyId: /^[A-Za-z0-9]{6}$/,
};
